<script lang="ts" setup>
import { ref, onMounted, computed, onBeforeMount, inject } from 'vue';
import axiosInstance from '@/plugins/axios';
import { useRoute, useRouter } from 'vue-router';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useToast } from 'primevue/usetoast';
import { getFaqsByLangId, saveFaqTranslation } from '../helper';


const gF = inject('gF') as any;
const rootLanguageId = ref(import.meta.env.VITE_ADMIN_DEFAULT_TRANSLATION_ID)
const toast = useToast();

const route = useRoute();
const router = useRouter();
const rootLangFaqs = ref({});
const targetLangFaqs = ref({});
const targetLanguageCode = ref('undefined');
const rootLanguageCode = ref('undefined');
const targetLangID = ref(route.params.translation);
const currentFaq = ref(route.params.faqID || 'undefined');
const isSaving = ref(false);



const getTargetFaqs = async () => {
    gF.startLoading();
    try {
        const response = await axiosInstance.get('/translations/' + targetLangID.value);
        targetLangFaqs.value = response.data.faqs;
        targetLanguageCode.value = response.data.languageCode;
    } catch (error) {
        console.log(error);
    }
}

const getRootFaqs = async () => {
    try {
        if (targetLanguageCode.value === 'en') {
            const response = await axiosInstance.get('/translations/670fad078be48456eb53b250');
            rootLangFaqs.value = response.data.faqs;
            console.log(rootLangFaqs.value[currentFaq.value].question);
            rootLanguageCode.value = "de";
            gF.endLoading();

        } else {
            const response = await axiosInstance.get('/translations/670e1e32d4634dd3c3ec7478');
            rootLangFaqs.value = response.data.faqs;
            console.log(rootLangFaqs.value);

            rootLanguageCode.value = "en";
            gF.endLoading();

        }
    } catch (error) {
        console.log(error);
        gF.endLoading();
    }
}

const checkIfFaqIsUndefined = async () => {
    if (targetLangFaqs.value[currentFaq.value] === undefined) {
        targetLangFaqs.value[currentFaq.value] = {
            question: '',
            answer: ''
        }
    }
}



const saveFaq = async () => {
    isSaving.value = true;
    await saveFaqTranslation(targetLangID.value, currentFaq.value, targetLangFaqs.value[currentFaq.value]);
    isSaving.value = false;
    router.go(-1);
}


onBeforeMount(async () => {
    rootLangFaqs.value = await getFaqsByLangId(rootLanguageId.value);
    targetLangFaqs.value = await getFaqsByLangId(targetLangID.value);
    await checkIfFaqIsUndefined(targetLangFaqs.value[currentFaq.value]);

})


</script>



<template>
    <div>
        <div class="row col-12 justify-content-center mb-3">
                <div class="col text-center">
                    <Button class="w-30 p-button-tuev" label="Save" @click="saveFaq()" iconPos="left" :loading="isSaving">
                        <template #icon>
                            <font-awesome-icon :icon="['fas', 'save']" />
                        </template>
                    </Button>
                </div>
            </div>
        <Card class="mb-3">
            <template #title>
                <div class="font-color-tuev">
                Root Language
                </div>
            </template>
            <template #content>
                <div class="row gap-2">
                    <div class="col-3 justify-content-center flex fw-bold">
                        <label for="setting">Question</label>
                    </div>
                    <div class="col-8" v-if="rootLangFaqs[currentFaq]">
                        <div v-html="rootLangFaqs[currentFaq].question"></div>
                    </div>
                    <div class="col-3 justify-content-center flex fw-bold">
                        <label for="setting">Answer</label>
                    </div>
                    <div class="col-8" v-if="rootLangFaqs[currentFaq]">
                        <div v-html="rootLangFaqs[currentFaq].answer"></div>
                    </div>
    
                </div>
            </template>
        </Card>

        <Card class="mb-5">
            <template #title>
                <div class="font-color-tuev">
                Target Language
                </div>
            </template>
            <template #content>
                <div class="row gap-2">
                    <div class="col-3 justify-content-center flex p-5 fw-bold">
                        <label for="setting">Question</label>
                    </div>
                    <div v-if="targetLangFaqs[currentFaq]" class="col-8">
                        <LimitedEditor v-model="targetLangFaqs[currentFaq].question" class="w-100" />
                    </div>
                    <div class="col-3  justify-content-center flex p-5 fw-bold">
                        <label for="setting">Answer</label>
                    </div>

                    <div v-if="targetLangFaqs[currentFaq]" class="col-8">
                        <LimitedEditor v-model="targetLangFaqs[currentFaq].answer" class="w-100" />
                    </div>
                </div>
            </template>
        </Card>
    </div>
</template>